import React from 'react';
import { IDeleteUniqueJoiningLinksJobDetails } from '../../../api/jobs.dao';
import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../jobs-monitor-host.viewmodel';
import { AlertErrorMessage } from '../../global/modal/alerts-host/types/alert/alert-error-message';
import { FormattedMessage } from 'react-intl';

const deleteUniqueJoiningLinksJobProperties: IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<IDeleteUniqueJoiningLinksJobDetails>> = {
    reviewFailedJobButtonText: 'Ok',
    reviewCompletedJobButtonText: 'Ok',
    completeComponent: () => {
        return <div>
            <FormattedMessage
             id='oe.job.allUniqueJoiningLinkDeleted'
             defaultMessage='All Unique Joining Links have been deleted.'
             description='Text'
            />
        </div>;
    },
    failedComponent: () => {
        return <AlertErrorMessage
            title='Deletion Failed'
            message='Deletion of Unique Joining Links has failed. Please open Edit Meeting Connections to delete the links manually.'
        />;
    },
};

export { deleteUniqueJoiningLinksJobProperties };